// ==============================|| OVERRIDES - TYPOGRAPHY ||============================== //

export default function Typography(theme) {
	return {
		MuiTypography: {
			styleOverrides: {
				gutterBottom: {
					// marginBottom: 12
				},
				defaultProps: {
					// variant: 'body',   // pick your default
				},
				root: {
					// color: theme.palette.primary[800]
					//theme.palette.primary[100]
					// fontSize: '0.915rem',
				}
			},
		}
	};
}
